
import { HomeIcon, MapPinIcon } from 'vue-feather-icons';
import addressMixin from '@/mixins/addressMixin.js';
import carriersMixin from '@/mixins/carriersMixin.js';
import cartMixin from '@/mixins/cartMixin.js';
import { mapState } from 'vuex';
import { Collapse, CollapseItem } from 'element-ui';
export default {
  name: 'CheckoutShippingType',
  mixins: [addressMixin, carriersMixin, cartMixin],

  data() {
    return {
      activeNames: [],
    };
  },
  computed: {
    ...mapState('checkout', ['shippingType', 'shippingAddress']),
    activeCarrierType() {
      if (Array.isArray(this.activeNames)) return this.activeNames[0] || null;
      return this.activeNames || null;
    },
  },
  methods: {
    setActiveCarrierType(carrierType) {
      if (!carrierType) return;
      this.activeNames = [carrierType];
      if (this.shippingType !== carrierType) {
        this.$store.commit('checkout/setShippingType', { data: carrierType });
      }
    },
    getFirstAvailableCarrierType(types = this.carrierTypes || []) {
      if (!Array.isArray(types) || !types.length) return null;
      return (
        types.find((type) => (this.carriers?.[type] || []).length > 0) || null
      );
    },
    setShippingTypeDefault() {
      if (!this.cartCarriers?.IdCarrier) return false;
      const targetId = Number(this.cartCarriers.IdCarrier);

      for (const carrierType of this.carrierTypes || []) {
        const typeList = this.carriers[carrierType] || [];
        if (typeList.some((c) => Number(c.IdCarrier) === targetId)) {
          this.setActiveCarrierType(carrierType);
          return true;
        }
      }
      return false;
    },
    ensureDefaultSelection() {
      const foundFromCart = this.setShippingTypeDefault();
      if (foundFromCart) return;

      const firstType = this.getFirstAvailableCarrierType();
      if (firstType) {
        this.setActiveCarrierType(firstType);
      }
    },
    setShippingType() {
      const carrierType = this.activeCarrierType;
      if (!carrierType) return;
      this.setActiveCarrierType(carrierType);
      // Auto-select the first carrier of the newly selected type
      this.autoSelectFirstCarrierOfType(carrierType);
    },
    autoSelectFirstCarrierOfType(carrierType) {
      const items = this.carriers?.[carrierType] || [];
      if (!items.length) return;

      this.$nextTick(() => {
        // Access the CheckoutCarriers component via ref
        const refArray = this.$refs['carriers_' + carrierType];
        const carriersComponent = Array.isArray(refArray) ? refArray[0] : refArray;

        if (carriersComponent?.$refs?.selectedCarrier?.setCarrier) {
          carriersComponent.$refs.selectedCarrier.setCarrier();
        }
      });
    },
    async fetchCarriers() {
      if (this._fetchTimer) clearTimeout(this._fetchTimer);
      this._fetchTimer = setTimeout(async () => {
        let options = {
          languageIsoCode: this.$i18n.locale,
          currencyIsoCode: this.$localisation.appCurrency.CurrencyIsoCode,
        };

        const addr = this.getAddressDelivery || this.shippingAddress;
        if (addr?.Postcode) {
          Object.assign(options, {
            postcode: addr.Postcode,
            city: addr.City,
            address1: addr.Address1,
            country: addr.Country,
            countryIsoCode: addr.CountryIsoCode,
            idCart: this.cartService.idCart,
          });
          // else {
          //   try {
          //     const visitor = await this.$axios.$get('/api/visitor');
          //     if (visitor?.ip) options.ip = visitor.ip;
          //   } catch (e) {}
          // }

          this.carriersService.fetchCarriers({
            ...options,
            onSuccess: (data) => {
              this.$nextTick(() => {
                const types = data?.Carriers || [];
                if (types.length > 0) {
                  this.ensureDefaultSelection();
                }
              });
            },
          });
        }
      }, 300);
    },
    async getIp() {
      try {
        const res = await this.$store.dispatch(
          'shop/localisation/fetchVisitor'
        );
        return res.ip;
      } catch (e) {
        return null;
      }
    },
  },
  watch: {
    'shippingAddress.Postcode': {
      handler() {
        this.fetchCarriers();
      },
      immediate: true,
    },
  },
  beforeDestroy() {
    if (this._fetchTimer) clearTimeout(this._fetchTimer);
  },
  components: {
    HomeIcon,
    MapPinIcon,
    Collapse,
    CollapseItem,
  },
};
